module.exports = __webpack_public_path__ + "img/coverImg.6230a30a.jpg";